import { ChangeDetectionStrategy, Component, computed, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EntityWithUuid, NkCardListItemAbstractComponent, NkCardListItemTag } from '@nk/ui-lib';

function isNkCardListItemTag(item: unknown): item is NkCardListItemTag {
  return !!item && item.hasOwnProperty('label') && item.hasOwnProperty('color');
}
function isNkCardListItemTagLink(item: unknown): item is NkCardListItemTag[] {
  return !!item && Array.isArray(item) && ((item.length > 0 && isNkCardListItemTag(item[0])) || item.length === 0);
}

@Component({
  selector: 'nk-card-list-item-tags',
  imports: [TranslateModule],
  templateUrl: './card-list-item-tags.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardListItemTagsComponent<Entity extends EntityWithUuid> extends NkCardListItemAbstractComponent<Entity> {
  public tags: Signal<NkCardListItemTag[] | null> = computed(() => {
    const value = this.valueSignal();
    if (value && value.entity && value.prop) {
      const item = value.entity && value.entity[value.prop];
      if (isNkCardListItemTagLink(item)) {
        return item;
      }
    }
    return null;
  });
}
